import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Linkedin, Twitter, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ab-primary text-white">
      <div className="ab-container py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-10 rounded-full bg-white text-ab-primary flex items-center justify-center font-serif text-xl">A</span>
            <span className="font-serif text-3xl">PranaOs</span>
          </div>
          <p className="font-serif text-3xl md:text-4xl leading-tight max-w-md text-white/90">
            The hospital OS that breathes with you.
          </p>
          <div className="mt-10 flex flex-col gap-3 text-white/70">
            <a href="mailto:hello@pranaos.com" className="flex items-center gap-3 hover:text-white">
              <Mail className="w-4 h-4" /> hello@pranaos.com
            </a>
            <span className="flex items-center gap-3"><MapPin className="w-4 h-4" /> Bengaluru · Mumbai · Delhi</span>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="ab-eyebrow text-white/50 mb-5">Product</p>
          <ul className="space-y-3 text-white/85">
            <li><Link to="/modules" className="hover:text-white">Modules</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/audit" className="hover:text-white inline-flex items-center gap-1.5" data-testid="footer-audit-link">Free Audit<span className="text-[9px] tracking-widest uppercase bg-ab-accent text-white px-1.5 py-0.5 rounded">PDF</span></Link></li>
            <li><a href="#compliance" className="hover:text-white">Compliance</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="ab-eyebrow text-white/50 mb-5">Company</p>
          <ul className="space-y-3 text-white/85">
            <li><a href="#about" className="hover:text-white">About</a></li>
            <li><a href="#careers" className="hover:text-white">Careers</a></li>
            <li><a href="#press" className="hover:text-white">Press</a></li>
            <li><a href="#contact" className="hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="ab-eyebrow text-white/50 mb-5">Talk to us</p>
          <a href="#contact" data-testid="footer-cta" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-ab-primary hover:bg-ab-accent hover:text-white transition">
            Book a demo <ArrowUpRight className="w-4 h-4" />
          </a>
          <div className="mt-8 flex items-center gap-3">
            <a href="#" aria-label="LinkedIn" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-ab-primary transition"><Linkedin className="w-4 h-4" /></a>
            <a href="#" aria-label="Twitter" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-ab-primary transition"><Twitter className="w-4 h-4" /></a>
            <a href="#" aria-label="GitHub" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-ab-primary transition"><Github className="w-4 h-4" /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="ab-container py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/55">
          <span>© {new Date().getFullYear()} PranaOs Health Systems Pvt. Ltd. — All rights reserved.</span>
          <div className="flex items-center gap-6">
            <a href="#privacy" className="hover:text-white">Privacy</a>
            <a href="#terms" className="hover:text-white">Terms</a>
            <a href="#status" className="hover:text-white">Status</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
